import React from "react";

export default function ProductImageSection({
  existingImage,
  selectedImage,
  selectedImagePreview,
  handleImageChange,
  removeExistingImage,
  removeSelectedImage,
}) {
  const existingImagePath =
    existingImage?.image_url || existingImage?.url || "";

  const existingImageSrc = existingImagePath
    ? existingImagePath.startsWith("http")
      ? existingImagePath
      : `https://kinewsstudiolimited.co.uk/${existingImagePath}`
    : "";

  return (
    <div className="md:col-span-2">
      <label className="mb-1.5 block text-sm font-medium text-slate-700">
        Product Image
      </label>

      <input
        type="file"
        accept="image/*"
        onChange={handleImageChange}
        className="w-full rounded-xl border border-slate-300 px-3 py-2 text-sm text-slate-900 outline-none transition file:mr-3 file:rounded-lg file:border-0 file:bg-slate-900 file:px-3 file:py-2 file:text-sm file:font-medium file:text-white hover:file:bg-slate-800"
      />

      <p className="mt-1.5 text-xs text-slate-500">
        Select one image for this product.
      </p>

      {existingImage && !selectedImage && (
        <div className="mt-3">
          <p className="mb-2 text-sm font-medium text-slate-700">
            Existing Image
          </p>

          <div className="rounded-xl border border-slate-200 bg-slate-50 p-3">
            {existingImageSrc ? (
              <img
                src={existingImageSrc}
                alt="Existing product"
                className="h-36 w-36 rounded-lg border border-slate-200 object-cover"
              />
            ) : (
              <div className="flex h-36 w-36 items-center justify-center rounded-lg border border-dashed border-slate-300 bg-white text-xs text-slate-400">
                No preview
              </div>
            )}

            <div className="mt-2 flex items-center justify-between gap-2">
              <span className="truncate text-xs text-slate-600">
                {(existingImage.image_url || existingImage.url || "")
                  .split("/")
                  .pop() || "Current image"}
              </span>

              <button
                type="button"
                onClick={removeExistingImage}
                className="shrink-0 text-sm font-medium text-red-600 hover:text-red-700"
              >
                Remove
              </button>
            </div>
          </div>
        </div>
      )}

      {selectedImage && (
        <div className="mt-3">
          <p className="mb-2 text-sm font-medium text-slate-700">New Image</p>

          <div className="rounded-xl border border-slate-200 bg-slate-50 p-3">
            {selectedImagePreview ? (
              <img
                src={selectedImagePreview}
                alt="Selected product"
                className="h-36 w-36 rounded-lg border border-slate-200 object-cover"
              />
            ) : (
              <div className="flex h-36 w-36 items-center justify-center rounded-lg border border-dashed border-slate-300 bg-white text-xs text-slate-400">
                No preview
              </div>
            )}

            <div className="mt-2 flex items-center justify-between gap-2">
              <span className="truncate text-xs text-slate-600">
                {selectedImage.name}
              </span>

              <button
                type="button"
                onClick={removeSelectedImage}
                className="shrink-0 text-sm font-medium text-red-600 hover:text-red-700"
              >
                Remove
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}